import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

import { PageContentBoundary } from './page-content-boundary'

export interface PageHeaderProps {
  actions?: ReactNode
  breadcrumbs?: ReactNode
  className?: string
  contentClassName?: string
  description?: string
  title?: string
}

export function PageHeader({
  actions,
  breadcrumbs,
  className,
  contentClassName,
  description,
  title,
}: PageHeaderProps) {
  const hasDescription = Boolean(description)
  const breadcrumbsOnly = Boolean(breadcrumbs && !title && !description)

  return (
    <header
      className={cn(
        'px-5 pt-5 lg:px-[30px]',
        hasDescription || breadcrumbsOnly ? 'pb-4' : 'pb-2',
        className,
      )}
    >
      <PageContentBoundary
        className={cn('flex items-start justify-between gap-4', contentClassName)}
      >
        <div className="flex min-w-0 items-center gap-2">
          <div className="min-w-0">
            {breadcrumbs ? <div className={cn(title ? 'mb-2' : null)}>{breadcrumbs}</div> : null}
            {title ? (
              <h1 className="text-[18px] leading-6 font-semibold text-[var(--color-text)]">
                {title}
              </h1>
            ) : null}
            {description ? (
              <p className="mt-1 text-sm leading-5 text-[#8c8e90]">{description}</p>
            ) : null}
          </div>
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-3">{actions}</div> : null}
      </PageContentBoundary>
    </header>
  )
}
